(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["blacks-drawer-menu"] && !Shopify.designMode) return;
  try {
    /* Horizon's drawer script writes aria-expanded="false" on every open
     <details> it closes (assets/header-drawer.js, reset()), and only sets
     "true" again for its own submenus. Keep our summaries in step with the
     native open state. toggle does not bubble, so listen in the capture phase. */
  document.addEventListener(
    'toggle',
    (event) => {
      const details = event.target;
      if (!(details instanceof HTMLDetailsElement) || !details.closest('.bl-drawer')) return;
      details.querySelector(':scope > summary')?.setAttribute('aria-expanded', String(details.open));
    },
    true
  );
  } catch(e) { console.error(e); }
})();

})();
